import { Flex } from "antd";

import { AntDSpin, AntDText } from "@arbolus-technologies/antDComponents";

import styles from "./Loader.module.scss";

export function FullscreenLoader({ message }: { message?: string }) {
  return (
    <Flex align="center" justify="center" className={styles.loadingWrapper}>
      <AntDSpin spinProps={{ size: "large" }} />
      {message && <AntDText>{message}</AntDText>}
    </Flex>
  );
}
